module.exports = __webpack_public_path__ + "img/lessReport.46cfe4ae.svg";